var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1977F3",
    d: "M7.659 7.414a1.911 1.911 0 0 1 3.347 0l5.259 9.3H5.85c-1.53 0-2.485-1.693-1.723-3.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002F81",
    d: "M16.342 7.414a1.912 1.912 0 0 0-3.347 0l-3.729 6.6c-.681 1.2.167 2.7 1.521 2.7h7.363c1.53 0 2.486-1.693 1.723-3.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMx0)",
    d: "M10.788 16.714h5.477L12 9.171l-2.738 4.843c-.677 1.2.171 2.7 1.525 2.7"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMx0",
    x1: 9.313,
    x2: 17.597,
    y1: 15.171,
    y2: 15.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1C6AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1C6AD9",
    stopOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/mx.63f8ee7633264b0cc28c15b2167df662.svg";
export { ForwardRef as ReactComponent };